<h1 class="page-title">{{ 'account.sections.saved' | t }}</h1>

@if (loading) {
  <p class="muted">{{ 'account.loading' | t }}</p>
} @else if (error) {
  <p class="error-text">{{error}}</p>
  <button type="button" class="btn-pill btn-pill-outline" (click)="load()">{{ 'account.retry' | t }}</button>
} @else if (products.length === 0) {
  <div class="empty-state">
    <mat-icon class="empty-icon">bookmark_border</mat-icon>
    <div>
      <h3>{{ 'account.saved.empty' | t }}</h3>
      <p class="muted">{{ 'account.saved.emptyHint' | t }}</p>
      <a class="btn-pill btn-pill-accent" routerLink="/">{{ 'account.saved.browse' | t }}</a>
    </div>
  </div>
} @else {
  @for (product of products; track product._id) {
    <article class="deal-row" [class.expired]="isExpired(product)">
      <a class="deal-thumb" [routerLink]="['/product', product._id]">
        @if (product.pictureUrl) {
          <img [src]="product.pictureUrl" [appImgFallback]="product.storedPictureUrl" [alt]="product.name" loading="lazy" />
        } @else {
          <mat-icon>local_offer</mat-icon>
        }
      </a>
      <div class="deal-body">
        <div class="deal-top">
          <span class="score"><mat-icon>local_fire_department</mat-icon>{{product.voteScore || 0}}°</span>
          @if (isExpired(product)) {
            <span class="expired-chip">{{ 'account.saved.expired' | t: { date: date(product.expirationDate) } }}</span>
          }
        </div>
        <a class="deal-title" [routerLink]="['/product', product._id]">{{product.name}}</a>
        <div class="deal-meta">
          @if (product.priceDiscount === 0) {
            <span class="price">{{ 'account.saved.free' | t }}</span>
          } @else if (product.priceDiscount) {
            <span class="price">{{product.priceDiscount | number:'1.0-2'}}€</span>
          }
          @if (product.price && product.price !== product.priceDiscount) {
            <span class="old-price">{{product.price | number:'1.0-2'}}€</span>
          }
          @if (product.percentageDiscount) {
            <span class="discount">-{{product.percentageDiscount}}%</span>
          }
          @if (product.promotionCode) {
            <span class="chip"><mat-icon>content_cut</mat-icon>{{product.promotionCode}}</span>
          }
          @if (merchant(product)) {
            <span>{{ 'account.saved.at' | t: { merchant: merchant(product) } }}</span>
          }
          @if (product.submittedByPseudo) {
            <span>{{ 'account.saved.sharedBy' | t: { pseudo: product.submittedByPseudo } }}</span>
          }
        </div>
        <div class="deal-actions">
          <span class="deal-meta">
            <a class="icon-link" [routerLink]="['/product', product._id]"><mat-icon>forum</mat-icon>{{product.commentCount || 0}}</a>
            <button type="button" class="icon-link" (click)="remove(product)" [attr.aria-label]="'account.saved.remove' | t" [title]="'account.saved.remove' | t">
              <mat-icon>bookmark</mat-icon>
            </button>
          </span>
          @if (product.affiliateUrl) {
            <a class="btn-pill btn-pill-muted" [href]="product.affiliateUrl" target="_blank" rel="noopener nofollow sponsored">
              {{ 'account.saved.seeDeal' | t }} <mat-icon>open_in_new</mat-icon>
            </a>
          }
        </div>
      </div>
    </article>
  }
}
